import { TagsSelect } from '../Form/TagsSelect/TagsSelect';
import { ImageUploadInput } from '../Form/ImageUploadInput/ImageUploadInput';
import { SubmitButton } from '../Form/SubmitButton/SubmitButton';
import { Form } from '../Form/Form';
import { Input } from '../Form/Input/Input';
import { Checkbox } from '../Form/Checkbox/Checkbox';
import { CategoriesSelect } from '../Form/CategoriesSelect/CategoriesSelect';
import { useTag } from '../../hooks/useTag';

import type { EnrichmentResponse } from '../../types';

import styles from './TagForm.module.scss';

type Props = {
  enrichment?: Partial<EnrichmentResponse>;
  onSubmit: (values: EnrichmentResponse) => Promise<void>;
};

function TagForm({ enrichment = {}, onSubmit }: Props) {
  const isNew = enrichment.id === undefined;
  const { data: tag } = useTag(enrichment.tagId ?? '');

  return (
    <Form<EnrichmentResponse>
      initialValues={enrichment as EnrichmentResponse}
      onSubmit={onSubmit}
    >
      {isNew && <TagsSelect label="Tag" name="tagId" />}
      {!isNew && (
        <Input label="Tag" value={tag?.title ?? ''} name="" disabled />
      )}
      <CategoriesSelect label="Related category" name="categoryId" />
      <Checkbox label="Use as a person profile" name="isProfile" />
      <ImageUploadInput label="Main image" name="images.main" aspectRatio={1} />
      <ImageUploadInput label="Background image" name="images.background" />
      <Input
        label="Description"
        name="description"
        type="textarea"
        size="big"
      />
      <div className={styles.buttons}>
        <SubmitButton>{isNew ? 'Create tag enrichment' : 'Save'}</SubmitButton>
      </div>
    </Form>
  );
}

export { TagForm };
